/*
	react-select component that will:
		1. collapse its ValueContainer (where the selected options show up) when not focused
		2. show its ValueContainer absolutely positioned, so that it can be used but NOT expand the height of its container
*/

import React from "react";
import { components } from "react-select";
import { LabeledDropDownSelect } from "../DropDownSelect";

const MaxHeightDropDownSelect = (props) => {
	const [isActive, setIsActive] = React.useState(false);

	// Applying a class name so we can change the ValueContainer's height by CSS
	const ValueContainer = React.useCallback(
		({ children, ...props }) => (
			<components.ValueContainer
				{...props}
				className={
					"maxHeightMultiselectValueContainer " +
					(props.className || "")
				}
			>
				{children}
			</components.ValueContainer>
		),
		[]
	);

	// Need a isFocused class so the css selector can work on the ValueContainer
	// Also notify parent component about focus state for z-index management
	const Control = React.useCallback(({ children, ...controlProps }) => {
		const focused = controlProps.isFocused;
		const menuIsOpen = controlProps.menuIsOpen;
		const className =
			"maxHeightMultiselectControl " +
			(controlProps.className || "") +
			" " +
			(focused ? "isFocused" : "");

		// Update parent state when focus or menu open state changes
		React.useEffect(() => {
			setIsActive(focused || menuIsOpen);
		}, [focused, menuIsOpen]);

		return (
			<components.Control {...controlProps} className={className}>
				{children}
			</components.Control>
		);
	}, []);

	const dynamicStyles = {
		menu: (base) => ({
			...base,
			zIndex: 9999,
		}),
		...(props.styles || {}),
	};

	return (
		<div style={{ position: "relative", zIndex: isActive ? 9999 : 1 }}>
			<LabeledDropDownSelect
				{...props}
				styles={dynamicStyles}
				onFocus={() => setIsActive(true)}
				onBlur={() => setIsActive(false)}
				onMenuOpen={() => setIsActive(true)}
				onMenuClose={() => setIsActive(false)}
				components={{
					Control,
					ValueContainer,
					...(props.components || {}),
				}}
			/>
		</div>
	);
};
export default MaxHeightDropDownSelect;
